export default __webpack_public_path__ + "static/media/8-2.b49322f1.mp3";